module.exports = __webpack_public_path__ + "static/media/29.5e32080e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/29.JPG
// module id = 472
// module chunks = 0